import { SidePanelLayerType } from "@nova/constants"
import { Category, DownloadType } from "./types"

export const stageKml = (
    kml: string,
    fileName: string,
    files: {
        blob: Blob
        name: string
    }[]
) => {
    files.push({
        blob: new Blob([kml], { type: "application/vnd.google-earth.kml+xml" }),
        name: `${fileName}.kml`,
    })
}

export type DownloadableLayerTypes = Extract<
    (typeof SidePanelLayerType)[keyof typeof SidePanelLayerType],
    "icon" | "line" | "ruler"
>

/**
 * The keys of each category must match the layerName property of a layer.
 */
export const rootCategories = (): Record<DownloadableLayerTypes, Category> => {
    return {
        [SidePanelLayerType.Icon]: {
            name: "Icons",
            downloadOptions: [
                { name: "KML", type: DownloadType.iconKml },
                { name: "SHP", type: DownloadType.iconShp },
            ],
        },
        [SidePanelLayerType.Line]: {
            name: "Lines & Polygons",
            downloadOptions: [
                { name: "KML", type: DownloadType.lineKml },
                { name: "SHP", type: DownloadType.lineShp },
            ],
        },
        [SidePanelLayerType.Ruler]: {
            name: "Rulers",
            downloadOptions: [
                { name: "KML", type: DownloadType.rulerKml },
                { name: "SHP", type: DownloadType.rulerShp },
            ],
        },
        // "hotspot-flight": {
        //     name: "Hotspots",
        //     categories: [
        //         {
        //             name: "Heat",
        //             categories: [
        //                 {
        //                     name: "Points",
        //                     downloadOptions: [
        //                         { name: "KML", type: DownloadType.hotspotHeatPointKml },
        //                         { name: "CSV", type: DownloadType.hotspotHeatPointCsv },
        //                         { name: "SHP", type: DownloadType.hotspotHeatPointShp },
        //                     ],
        //                 },
        //                 {
        //                     name: "Polygons",
        //                     downloadOptions: [
        //                         { name: "KML", type: DownloadType.hotspotHeatPolyKml },
        //                         { name: "SHP", type: DownloadType.hotspotHeatPointShp },
        //                     ],
        //                 },
        //                 // {
        //                 //     name: "Orthomosaics",
        //                 //     downloadOptions: [
        //                 //         { name: "TIFF", type: DownloadType.hotspotHeatOrthoTiff },
        //                 //         { name: "JPG", type: DownloadType.hotspotHeatOrthoJpg },
        //                 //         { name: "PNG", type: DownloadType.hotspotHeatOrthoPng },
        //                 //         { name: "KMZ", type: DownloadType.hotspotHeatOrthoKmz },
        //                 //     ],
        //                 // },
        //             ],
        //         },
        //         {
        //             name: "Path",
        //             downloadOptions: [
        //                 { name: "KML", type: DownloadType.hotspotPathKml },
        //                 { name: "SHP", type: DownloadType.hotspotPathShp },
        //             ],
        //         },
        //         // {
        //         //     name: "Images",
        //         //     downloadOptions: [{ name: "ZIP", type: DownloadType.hotspotImagesZip }],
        //         // },
        //     ],
        // },
        // "fire-perimeter": {
        //     name: "Fire Perimeters",
        //     downloadOptions: [{ name: "KML", type: DownloadType.firePerimeterKml }],
        // },
        // "orthomosaic-flight": {
        //     name: "Orthomosaics",
        //     categories: [
        //         // {
        //         //     name: "Orthomosaics",
        //         //     downloadOptions: [
        //         //         { name: "TIFF", type: DownloadType.orthoOrthoTiff },
        //         //         { name: "JPG", type: DownloadType.orthoOrthoJpg },
        //         //         { name: "PNG", type: DownloadType.orthoOrthoPng },
        //         //         { name: "KMZ", type: DownloadType.orthoOrthoKmz },
        //         //     ],
        //         // },
        //         // {
        //         //     name: "DEM",
        //         //     downloadOptions: [{ name: "TIFF", type: DownloadType.orthoDemTiff }],
        //         // },
        //         {
        //             name: "Path",
        //             downloadOptions: [
        //                 { name: "KML", type: DownloadType.orthoPathKml },
        //                 { name: "SHP", type: DownloadType.orthoPathShp },
        //             ],
        //         },
        //     ],
        // },
        // "video-flight": {
        //     name: "Full Motion Video",
        //     downloadOptions: [
        //         { name: "MP4", type: DownloadType.videoMp4 },
        //         { name: "SRT", type: DownloadType.videoSrt },
        //     ],
        // },
        // "color-finder": {
        //     name: "Colorfinder",
        //     downloadOptions: [
        //         { name: "MP4", type: DownloadType.colorFinderMp4 },
        //         { name: "SRT", type: DownloadType.colorFinderSrt },
        //         { name: "JPG", type: DownloadType.colorFinderJpg },
        //     ],
        // },
    }
}
